import { URLS } from '../constants'
import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut, RESPONSE_TYPE } from './ActionsUtil'
import {
  GET_CUSTOMER_INFORMATION_BEGIN, GET_CUSTOMER_INFORMATION_SUCCESS, GET_CUSTOMER_INFORMATION_FAILURE,
  POST_CUSTOMER_SOFT_BLOCK_BEGIN, POST_CUSTOMER_SOFT_BLOCK_SUCCESS, POST_CUSTOMER_SOFT_BLOCK_FAILURE,
  POST_CUSTOMER_UNBLOCK_BEGIN, POST_CUSTOMER_UNBLOCK_SUCCESS, POST_CUSTOMER_UNBLOCK_FAILURE,
  PUT_UPDATE_CUSTOMER_BEGIN, PUT_UPDATE_CUSTOMER_SUCCESS, PUT_UPDATE_CUSTOMER_FAILURE, CLEAR_UPDATE_CUSTOMER_DATA
} from '../constants/ActionTypes'

// Get Customer Info
const acGetCustomerInformationBegin = () => ({ type: GET_CUSTOMER_INFORMATION_BEGIN, })
const acGetCustomerInformationSuccess = payload => ({
  type: GET_CUSTOMER_INFORMATION_SUCCESS, payload
})
const acGetCustomerInformationFailure = err => ({
  type: GET_CUSTOMER_INFORMATION_FAILURE, payload: err
})

export const acGetCustomerInformation = () => {
  return dispatchFetchGet(
    URLS.CURRENT_CUSTOMER,
    acGetCustomerInformationBegin,
    acGetCustomerInformationSuccess,
    acGetCustomerInformationFailure,
  )
}


// Update Customer
const acPutUpdateCustomerBegin = () => ({ type: PUT_UPDATE_CUSTOMER_BEGIN, })
const acPutUpdateCustomerSuccess = payload => ({
  type: PUT_UPDATE_CUSTOMER_SUCCESS, payload
})
const acPutUpdateCustomerFailure = err => ({
  type: PUT_UPDATE_CUSTOMER_FAILURE, payload: err
})

export const acPutUpdateCustomer = (customerId, data) => {
  return dispatchFetchPut(
    `${URLS.CUSTOMER}/${customerId}`,
    data,
    acPutUpdateCustomerBegin,
    acPutUpdateCustomerSuccess,
    acPutUpdateCustomerFailure,
  )
}

export const acClearUpdateCustomerData = () => ({ type: CLEAR_UPDATE_CUSTOMER_DATA })


// Unblock Customer
const acUnblockCustomerBegin = () => ({ type: POST_CUSTOMER_UNBLOCK_BEGIN, })
const acUnblockCustomerSuccess = payload => ({
  type: POST_CUSTOMER_UNBLOCK_SUCCESS, payload: { response: payload }
})
const acUnblockCustomerFailure = err => ({
  type: POST_CUSTOMER_UNBLOCK_FAILURE, payload: err
})

export const acUnblockCustomer = (customerId) => {
  return dispatchFetchPost(
    `${URLS.UNBLOCK}/${customerId}`,
    {},
    acUnblockCustomerBegin,
    acUnblockCustomerSuccess,
    acUnblockCustomerFailure,
    RESPONSE_TYPE.NONE
  )
}


//Block Customer
const acBlockCustomerBegin = () => ({ type: POST_CUSTOMER_SOFT_BLOCK_BEGIN, })
const acBlockCustomerSuccess = payload => ({
  type: POST_CUSTOMER_SOFT_BLOCK_SUCCESS, payload: { response: payload }
})
const acBlockCustomerFailure = err => ({
  type: POST_CUSTOMER_SOFT_BLOCK_FAILURE, payload: err
})

export const acBlockCustomer = (customerId) => {
  return dispatchFetchPost(
    `${URLS.BLOCK}/${customerId}`,
    {},
    acBlockCustomerBegin,
    acBlockCustomerSuccess,
    acBlockCustomerFailure,
    RESPONSE_TYPE.NONE
  )
}